import React, { useState, useEffect } from 'react'
import { API, graphqlOperation } from 'aws-amplify'
import { useSelector } from 'react-redux'
import { useGenerateAdminHSK } from '../customHooks'
import { setFloorWardenRequests } from '../redux/floorWarden/actions'

const query = `query($sk: String, $d1: String) {
    listRequests(sk: $sk, d1: $d1) {
        items {
            createdAt
            email
            pk
            d1
            sk
            firstName
            lastName
            floor
            suite
            tenant
            building
            type
            position
            acknowledged
        }
        nextToken
    }
}`

const cache = {}

export const useFetchFloorWardenRequests = () => {
    const [data, setData] = useState([])
    const [errors, setErrors] = useState(null)
    const [loading, setLoading] = useState(true)

    const isAdmin = useSelector(state => state.app.isAdmin)
    const roles = useSelector((state) => state.app.user.roles)

    const hsk = useGenerateAdminHSK()

    const handler = (_data) => {
        setFloorWardenRequests(_data)
        setLoading(false)
    }
    
    useEffect(() => {

        async function fetch() {
            let cached = cache[hsk]
            if (cached) handler(cached)
    
            try {
                const response = await API.graphql(graphqlOperation(query, { d1: hsk, sk: 'FLOOR_WARDEN_REQUEST' }))
                cached = response.data.listRequests.items
                handler(cached)
            } catch (response) {
                console.error(response)
                console.error(response.errors)
                setErrors(response.errors)
            }
        }

        if (hsk && isAdmin && !roles.includes('TENANT_ADMIN')) {
            fetch()
        } else {
            setErrors('Could not find a building id')
        }

    }, [hsk, isAdmin, roles])

    return { loading, errors }
}
